module.exports = __webpack_public_path__ + "static/media/Hand coding-bro.84d5530c.svg";